import React from "react";
import { gql } from "apollo-boost";

import SettingsList from "superAdminViews/setting/SettingsList";

const ADD = gql`
  mutation createCarBrandByAdmin($name: String!) {
    createCarBrandByAdmin(input: { name: $name }) {
      _id
      name
    }
  }
`;

const GET = gql`
  query getCarBrands($limit: Int, $skip: Int, $name: String) {
    getCarBrands(pagination: { limit: $limit, skip: $skip }, filters: { name: $name }) {
      _id
      name
    }
  }
`;

const COUNT = gql`
  query getCarBrandsCount {
    getCarBrandsCount
  }
`;

const UPDATE = gql`
  mutation updateCarBrandByAdmin($id: ID!, $name: String!) {
    updateCarBrandByAdmin(id: $id, input: { name: $name }) {
      _id
      name
    }
  }
`;

const DELETE = gql`
  mutation deleteCarBrandByAdmin($idSet: [ID!]!) {
    deleteCarBrandByAdmin(idSet: $idSet) {
      _id
    }
  }
`;

const IMPORT = gql`
  mutation addCarBrandViaExcel($excelFile: Upload!) {
    addCarBrandViaExcel(excelFile: $excelFile)
  }
`;

/**
 * Brands - the car makes a driver can pick from.
 *
 * The spreadsheet template used to be built from
 * `[['Name'], ['Benz'], ['Mazda']['Kia']]` — that last pair indexes an
 * array with a string, so the third row came out undefined.
 */
const Brands = () => (
  <SettingsList
    title="Brands"
    description="The car makes drivers choose from when registering a vehicle."
    singular="brand"
    list={{ query: GET, key: "getCarBrands" }}
    count={{ query: COUNT, key: "getCarBrandsCount" }}
    searchFilter="name"
    countFilters={[]}
    create={{ mutation: ADD, variables: (values) => ({ name: values.name.trim() }) }}
    update={{
      mutation: UPDATE,
      variables: (values, row) => ({ id: row._id, name: values.name.trim() }),
    }}
    remove={{ mutation: DELETE }}
    importExcel={{
      mutation: IMPORT,
      templateRows: [["Name"], ["Benz"], ["Mazda"], ["Kia"]],
      fileName: "Spark-Brands-Template.xlsx",
    }}
    columns={[{ key: "name", label: "Brand", width: "3fr" }]}
    fields={[{ name: "name", label: "Brand", type: "text", required: true }]}
    toValues={(row) => ({ name: row.name })}
  />
);

export default Brands;
